export const individualHashHelper = ({ field, chart, analyticsState }) => {
  if (field === 'activeDateInterval' || field === 'sentimentDateInterval' || field === 'tweetsDateInterval') {
    if (analyticsState[field].name === 'Custom') {
      return `between-${analyticsState[field].filter[0]}-and-${analyticsState[field].filter[1]}`;
    } else {
      return analyticsState[field].name;
    }
  } else if (field === 'typeOfChart' && chart === 'Sentiment changes') {
    return analyticsState['typeOfChartSentimentChanges'];
  } else if (field === 'chartDataOptionSelected' && chart === 'Tweets') {
    return analyticsState['chartDataOptionSelectedTweets'];
  } else if (field === 'chartDataOptionSelected' && chart === 'Sentiment changes') {
    return analyticsState['chartDataOptionSelectedSentimentChanges'];
  } else if (field === 'typeOfChart' && chart === 'Interest by region') {
    return analyticsState['typeOfChartInterestByRegion'];
  } else if (field === 'selectedCountries') {
    if (chart === 'Interest by region') {
      return analyticsState['selectedCountriesInterestByRegion'].map((item) => item.value).join('-');
    } else {
      return analyticsState[field].map((item) => item.value).join('-');
    }
  } else if (field === 'chartDataOptionSelected' && analyticsState[field] === 'Overall') {
    return 'none';
  } else if (field === 'allowFrontbenchers') {
    return `${analyticsState[field]}`;
  } else if (field === 'includeXRepostsTweetsSection') {
    return `${analyticsState[field]}`;
  } else {
    return analyticsState[field];
  }
};
